import React, { useEffect, useRef, useState } from "react";
import { Box, Paper, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import "./MainNavigation.css";
import { ShepLogo, QuestionMark, Bell, User, Search } from "../../ImageRepo";
import { MenuItemEnum } from "@/utils/utils";
import PropType from "prop-types";
import ShepButton from "@/components/GenericComponents/ShepButton";
import axios from "@/features/axiosHelper";
import { HELP_CENTER_FLOW_ID } from "@/features/appcuesHelper";

// const NavigationTile = (props) => {
//   return (
//     <Link to={props.link}>
//       <Paper className="main-nav-items" elevation={1}>
//         <img className="inactive" src={props.icon} />
//         <img className="hover" src={props.iconHover} />
//         <img className="active" src={props.iconClicked} />
//       </Paper>
//       <Typography
//         variant="body2"
//         style={{ fontWeight: props.checked ? "bold" : "normal" }}
//       >
//         {props.label}
//       </Typography>
//     </Link>
//   );
// };

const NavigationTileText = (props) => {
  return (
    <Link to={props.link}>
      <Box
        className="child-nav-container-text"
        onClick={() => {
          window.heap.track(`Header - Click ${props.label}`);
        }}
      >
        <Typography
          variant="body1"
          style={{
            fontWeight: props.checked ? "bold" : "normal",
            fontSize: props.checked ? "20px" : "inherit",
          }}
        >
          {props.label}
        </Typography>
      </Box>
    </Link>
  );
};

const NavigationTileIcon = (props) => {
  return (
    <Link
      className="child-nav-container-icons"
      to={props.link}
      onClick={props.onClick}
    >
      <Box>
        <img src={props.source} draggable="false" />
      </Box>
    </Link>
  );
};

const MainNavigation = ({ selected }) => {
  const tenantName = localStorage.getItem("tenantName");

  const onClick_Search = () => {
    alert("search clicked");
  };

  //Virtual Packing
  const [vpWindow, setVPWindow] = useState(null);
  const intervalRef = useRef();
  const [targetURL, setTargetURL] = useState(null);
  const [pingStarted, setPingStarted] = useState(false);
  useEffect(() => {
    if (vpWindow !== null && !pingStarted) {
      intervalRef.current = setInterval(() => {
        vpWindow.postMessage("ping", targetURL);
      }, 1000);
      setPingStarted(true);
    }
    const CatchVPResponse = async (event) => {
      if (event.origin !== targetURL) return;
      clearInterval(intervalRef.current);

      const refreshToken = localStorage.getItem("refreshToken");
      vpWindow.postMessage({ refreshToken }, event.origin);
      setVPWindow(null);
      setPingStarted(false);
    };
    window.addEventListener("message", CatchVPResponse, false);
    return () => {
      window.removeEventListener("message", CatchVPResponse);
      clearInterval(intervalRef.current);
    };
  }, [vpWindow, targetURL]);
  //Virtual Packing

  return (
    <Container>
      <Box className="main-nav-container">
        <Box className="child-nav-container-1">
          <Box className="shep-logo">
            <img src={ShepLogo} draggable="false" />
          </Box>
          <NavigationTileText
            link="/homepage"
            label="Home"
            checked={selected === MenuItemEnum.Homepage}
          />
          <NavigationTileText
            link="/maintenance"
            label="Maintenance"
            checked={selected === MenuItemEnum.Maintenance}
          />
          <NavigationTileText
            link="/integrations"
            label="Integrations"
            checked={selected === MenuItemEnum.Integrations}
          />
        </Box>
        <Box className="child-nav-container-2">
          <NavigationTileIcon
            onClick={() => {
              window.Appcues?.show(HELP_CENTER_FLOW_ID);
              window.heap.track("Header - Click Help Icon");
            }}
            source={QuestionMark}
            checked={selected === MenuItemEnum.Support}
          />
          <NavigationTileIcon
            link="/profile"
            source={User}
            checked={selected === MenuItemEnum.Profile}
            onClick={() => {
              window.heap.track(`Header - Click Profile Icon`);
            }}
          />
          <NavigationTileIcon
            link="/notifications"
            source={Bell}
            checked={selected === MenuItemEnum.Notifications}
            onClick={() => {
              window.heap.track(`Header - Click Notifications Icon`);
            }}
          />
          <NavigationTileIcon
            link=""
            source={Search}
            checked={selected === MenuItemEnum.Search}
          />

          <Typography variant="body1" sx={{ px: 2 }}>
            {tenantName}
          </Typography>

          {/*<ShepButton*/}
          {/*  variant="primary"*/}
          {/*  onClick={async () => {*/}
          {/*    // We are obliged to open the window immediately or the popup will be blocked by default.*/}
          {/*    const newWindow = window.open("about:blank", "_blank");*/}
          {/*    if (newWindow) newWindow.opener = null; //security measure*/}

          {/*    try {*/}
          {/*      const response = await axios.get(*/}
          {/*        "/endpoint/external/VirtualPacking"*/}
          {/*      );*/}
          {/*      const url = response.data;*/}
          {/*      setTargetURL(url);*/}

          {/*      // Now redirect the already-open window to the actual URL*/}
          {/*      if (newWindow) {*/}
          {/*        newWindow.location.href = url;*/}
          {/*        setVPWindow(newWindow);*/}
          {/*      }*/}
          {/*    } catch (error) {*/}
          {/*      // If request fails, close the blank window*/}
          {/*      if (newWindow) {*/}
          {/*        newWindow.close();*/}
          {/*      }*/}
          {/*      console.error("Failed to get Virtual Packing URL:", error);*/}
          {/*    }*/}
          {/*  }}*/}
          {/*>*/}
          {/*  Virtual Packing*/}
          {/*</ShepButton>*/}
        </Box>
      </Box>
    </Container>
  );
};

export default MainNavigation;
